import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { faSearch } from '@fortawesome/pro-duotone-svg-icons/faSearch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { faComments } from '@fortawesome/pro-solid-svg-icons'
import ChatTable from 'components/ui/chat/variants/chatTable/ChatTable'
import { IChatMessageModel } from 'models/chatMessage.model'
import * as fromChatActions from 'store/actions/chat.action'
import { IMainState } from 'store/states'
import { ContentContainer } from 'components/ui/content-container/ContentContainer'
import styles from './Messages.module.scss'

export const Messages = () => {
  const { user } = useSelector(({ user }: IMainState) => user)
  const { unreadMessagesCount } = useSelector(({ chat }: IMainState) => chat)
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: fromChatActions.GET_UNREAD_MESSAGES_COUNT })
  }, [dispatch])

  useEffect(() => {
    user.token &&
      dispatch({
        type: fromChatActions.GET_CONVERSATIONS,
        payload: {
          token: user.token,
        },
      })
  }, [dispatch, user])

  const onSendMessage = (data: IChatMessageModel) => {
    dispatch({
      type: fromChatActions.CREATE_CHAT_MESSAGE,
      payload: { ...data, identifier: user.identifier },
    })
  }

  return (
    <ContentContainer title={t('components.chat.tabTitle')}>
      <Row className="d-flex align-items-center">
        <Col>
          <div className={styles.count}>
            <FontAwesomeIcon icon={faComments} />

            {`${t('components.chat.haveNewMessages.base')} ${
              unreadMessagesCount || 0
            } ${t(
              `components.chat.haveNewMessages.${
                unreadMessagesCount > 1 ? 'plural' : 'singular'
              }`
            )} `}
          </div>
        </Col>

        <Col>
          <div className={styles.search}>
            <input
              type="text"
              value={search}
              onChange={({ target }) => setSearch(target.value)}
              placeholder={t('administration.certificate.list.search')}
            />
            <FontAwesomeIcon icon={faSearch} className="icon" />
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="pr-0">
          <div className={styles.tableContainer}>
            <ChatTable onSend={onSendMessage} search={search} />
          </div>
        </Col>
      </Row>
    </ContentContainer>
  )
}
